import { Table } from "@similarweb/pro-logic-components";

import { useTranslation } from "pro-features/components/WithTranslation";

import { useCompactData } from "../../../hooks/useCompactData";
import type { TrafficSource } from "../../../traffic-sources-tabs";
import { useShareOfWebsiteTrafficData } from "../hooks/useShareOfWebsiteTrafficData";

import { type Data, useColumnsConfig } from "./useColumnsConfig";

interface IShareOfWebsiteTrafficTable {
    trafficSource: TrafficSource;
}

export const ShareOfWebsiteTrafficTable = ({ trafficSource }: IShareOfWebsiteTrafficTable) => {
    const translate = useTranslation();
    const { data, isLoading } = useShareOfWebsiteTrafficData(trafficSource);
    const compactData = useCompactData({ data });
    const columnsConfig = useColumnsConfig();

    return (
        <Table<Data>
            data={compactData}
            columnConfig={columnsConfig}
            isLoading={isLoading}
            noData={{
                title: translate("global.nodata.notavilable"),
            }}
            tableLayout="auto"
            highlightedRowSelector={(record) => !Array.isArray(record.domain) && !!record.domain.isPrimaryDomain}
        />
    );
};
